package com.wsa.hawebapp

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.launch

@Composable
fun App() {
    MaterialTheme {
        val scope = rememberCoroutineScope()
        var isScanning by remember { mutableStateOf(false) }
        var devices by remember { mutableStateOf(listOf<BleDevice>()) }
        var statusMessage by remember { mutableStateOf("") }

        LaunchedEffect(Unit) {
            devices = getBondedDevices()
        }

        Column(
            modifier = Modifier
                .background(MaterialTheme.colorScheme.primaryContainer)
                .safeContentPadding()
                .fillMaxSize(),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            // Paired devices list — grows to fill available space
            if (devices.isNotEmpty()) {
                Text(
                    text = "Paired Devices (${devices.size}):",
                    style = MaterialTheme.typography.titleSmall,
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = 16.dp, vertical = 4.dp)
                )
            }
            LazyColumn(
                modifier = Modifier
                    .fillMaxWidth()
                    .weight(1f)
                    .padding(horizontal = 16.dp)
            ) {
                items(devices) { device ->
                    Card(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(vertical = 4.dp)
                    ) {
                        Column(modifier = Modifier.padding(12.dp)) {
                            Text(
                                text = device.name,
                                style = MaterialTheme.typography.bodyLarge
                            )
                            Text(
                                text = "ID: ${device.id}",
                                style = MaterialTheme.typography.bodySmall,
                                color = MaterialTheme.colorScheme.onSurfaceVariant
                            )
                        }
                    }
                }
            }

            // Scan button pinned at the bottom
            if (statusMessage.isNotEmpty()) {
                Text(
                    text = statusMessage,
                    style = MaterialTheme.typography.bodySmall,
                    modifier = Modifier.padding(bottom = 8.dp)
                )
            }
            Button(
                enabled = !isScanning,
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 16.dp, vertical = 12.dp),
                onClick = {
                    scope.launch {
                        isScanning = true
                        statusMessage = "Opening device picker…"
                        val device = requestBleDevice()
                        if (device != null) {
                            if (devices.none { it.id == device.id }) {
                                devices = devices + device
                            }
                            statusMessage = "Added: ${device.name}"
                        } else {
                            statusMessage = "No device selected."
                        }
                        isScanning = false
                    }
                }
            ) {
                Text(if (isScanning) "Scanning…" else "Start Scan")
            }
        }
    }
}